import { createPromiseAction } from 'redux-saga-promise-actions';
import { AddNewsletterSubscriberPayload } from 'store/types/newsletter';

export const addNewsletterSubscriber = createPromiseAction(
  'ADD_NEWSLETTER_SUBSCRIBER',
  'ADD_NEWSLETTER_SUBSCRIBER_SUCCEEDED',
  'ADD_NEWSLETTER_SUBSCRIBER_FAILURE',
)<AddNewsletterSubscriberPayload, undefined, undefined>();
